import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import AddIntent from "./AddIntent";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { data, useNavigate, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { useGetAllIntentMutation, useGetIntentByIdMutation, useImportKnowledgebaseMutation, useUpdateKnowledgebaseMutation } from "./Api";
import { FaChevronDown, FaChevronUp, FaEdit, FaPlus, FaTimes } from "react-icons/fa";
import Knowledgebase from "./Knowledgebase";
import toastService from "../../services/toastService";
import Swal from "sweetalert2";
import moment from 'moment'
import {
    FiAlertTriangle,
    FiUploadCloud,
    FiFileText,
    FiX,
    FiCheckCircle,
    FiArrowRight,
    FiAlertCircle,
    FiTrash2,
    FiEdit2,
    FiChevronDown,
    FiChevronRight,
    FiInbox,
    FiXCircle
} from "react-icons/fi";

const KBCategory = () => {

    const [getAllIntentApi, { isLoading }] = useGetAllIntentMutation()
    const [getIntentByIdApi, { isLoading: getIntentByIdIsloading }] = useGetIntentByIdMutation()
    const [importKnowledgebaseApi, { isLoading: importKnowledgeIsloading }] = useImportKnowledgebaseMutation()
    const [updateKnowledgebaseApi, { isLoading: updateKnowledgeIsloading }] = useUpdateKnowledgebaseMutation()



    const [intent, setIntent] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const navigate = useNavigate()

    const requestIdRef = useRef(0);

    const searchInputRef = useRef(null);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000);

        return () => clearTimeout(handler);
    }, [search]);

    useEffect(() => {
        getAllIntent()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);


    const getAllIntent = async () => {
        try {
            const requestId = ++requestIdRef.current;

            const response = await getAllIntentApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch
            })

            // keep cursor in search input
            if (search) {
                setTimeout(() => {
                    searchInputRef.current?.focus();
                }, 1);
            }

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                setIntent(response?.data?.data?.intent)
                setTotalRecords(response?.data?.data?.pagination.total || 0);
                setTotalPages(response?.data?.data?.pagination.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // import

    const [previewData, setPreviewData] = useState([]);

    const [showPreview, setShowPreview] = useState(false);

    const [importStep, setImportStep] = useState(1);


    const handleExcelUpload = async (file) => {

        // validate extension
        const allowed = [
            // "txt",
            "pdf",
            "docx",
            "xlsx",
            "csv",
            // "json",
            // "pptx",
            // "png",
            // "jpg",
            // "jpeg"
        ];

        const ext = file.name.split(".").pop().toLowerCase();

        if (!allowed.includes(ext)) {
            // setShowPreview(false)
            toastService.error("Unsupported file format. Please select a valid file.");
            return;
        }

        const formData = new FormData();

        formData.append("file", file);

        const response = await importKnowledgebaseApi(formData)

        if (response?.data?.success) {
            setPreviewData(response?.data?.data)
            setImportStep(2);
        } else {
            // setShowPreview(false)
            // toastService.error(response?.error?.data?.message)
            toastService.error("KB import failed")
            setImportStep(1)
        }

    };

    const handleDeleteIntent = async (intentIndex) => {

        const isDarkMode = localStorage.getItem("theme") === "dark";

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Deleting this category will also delete all associated flows, questions and options.",
            icon: "warning",

            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",

            confirmButtonColor: "#d32f2f",
            cancelButtonColor: isDarkMode ? "#475569" : "#757575",

            background: isDarkMode ? "#1e293b" : "#fdfdfd",
            color: isDarkMode ? "#f8fafc" : "#212121",

            iconColor: "#ef4444",

            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true,

            customClass: {
                popup: isDarkMode ? "swal-dark-popup" : "",
                title: isDarkMode ? "swal-dark-title" : "",
                confirmButton: isDarkMode ? "swal-dark-confirm" : "",
                cancelButton: isDarkMode ? "swal-dark-cancel" : "",
            },
        });

        if (!result.isConfirmed) return;

        setPreviewData((prev) =>
            prev.filter((_, index) => index !== intentIndex)
        );

        // setPreviewData((prev) => {
        //     const updated = prev.filter(
        //         (_, index) => index !== intentIndex
        //     );

        //     console.log(updated, "after delete");

        //     return updated;
        // });

        // console.log(previewData,'456')
    };

    const [showEditModal, setShowEditModal] = useState(false);

    const [editData, setEditData] = useState(null);

    const [editIndex, setEditIndex] = useState(null);

    const [expandedIntent, setExpandedIntent] = useState(null);

    const [expandedFlow, setExpandedFlow] = useState(null);

    const [validationErrors, setValidationErrors] = useState([]);


    const handleEditIntent = (intent, index) => {

        setEditData(structuredClone(intent));

        setEditIndex(index);

        setShowEditModal(true);

    };

    const updateEditValue = (path, value) => {

        setEditData(prev => {

            const data = structuredClone(prev);

            let current = data;

            for (let i = 0; i < path.length - 1; i++) {
                current = current[path[i]];
            }

            current[path[path.length - 1]] = value;

            return data;
        });

    };

    const [expandedFlows, setExpandedFlows] = useState({});

    const toggleFlow = (index) => {
        setExpandedFlows((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const handleUpload = async () => {
        try {
            // console.log(previewData, 'preview')
            const response = await updateKnowledgebaseApi({ import_data: previewData })
            console.log(response, 'response')
            if (response?.data?.success) {
                setShowPreview(false)
                setPreviewData([])
                setImportStep(1);
                setExpandedFlows({})
                setExpandedFlow(null)
                setExpandedIntent(null)
                setStatus(!status)
                toastService.success("Knowledge base uploaded successfully")
            } else {
                // toastService.error(response?.data?.error?.me)
                // console.log(response?.data?.error)
                const errors = response?.error?.data?.message || [];
                setValidationErrors(errors);
                setImportStep(4);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const handlePreviewIcon = () => {
        if (previewData.length > 0) {
            setImportStep(2)
        }
    }


    const [keywordInput, setKeywordInput] = useState("");

    const addKeyword = () => {
        const value = keywordInput.trim();

        if (!value) return;

        updateEditValue(
            ["keywords"],
            [...(editData.keywords || []), value]
        );

        setKeywordInput("");
    };

    const removeKeyword = (index) => {
        const updatedKeywords = editData.keywords.filter(
            (_, i) => i !== index
        );

        updateEditValue(["keywords"], updatedKeywords);
    };

    return (
        <div>
            {isLoading || getIntentByIdIsloading || importKnowledgeIsloading || updateKnowledgeIsloading ? <Loader /> :
                <div>

                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Knowledge Base</li>
                                <li className="breadcrumb-item active">KB Management</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">
                                {/* Title */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Knowledge Base Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage Issue Category, Troubleshooting Flow, Questions and Customer Responses
                                        </p>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-success"
                                            onClick={() => setShowPreview(true)}
                                        >
                                            Import KB
                                        </button>

                                        <button className="btn btn-primary"
                                            onClick={() => navigate(`/createKnowledgebase`)}
                                        >
                                            Create KB
                                        </button>
                                    </div>

                                </div>

                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="row justify-content-end g-3">

                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">

                                                <input
                                                    ref={searchInputRef}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search category by name..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Category Name</th>
                                                    <th>Description</th>
                                                    <th>Keywords</th>
                                                    <th>Status</th>
                                                    <th>Created at</th>
                                                    <th>Updated at</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && intent?.length > 0 ? (
                                                    intent?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.intent_name}</td>
                                                            <td style={{
                                                                width: "250px",
                                                                maxWidth: "250px",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                            }}>{item.description}</td>
                                                            {/* <td>
                                                                {item.keywords && item.keywords.length > 0 ? (
                                                                    item?.keywords?.map((kw, i) => (
                                                                        <span
                                                                            key={i}
                                                                         
                                                                            className="keyword-tag"
                                                                        >
                                                                            {kw}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td> */}
                                                            <td>
                                                                <div className="keywords-container">
                                                                    {item.keywords && item.keywords.length > 0 ? (
                                                                        item.keywords.map((kw, i) => (
                                                                            <span
                                                                                key={i}
                                                                                className="keyword-tag"
                                                                            >
                                                                                {kw}
                                                                            </span>
                                                                        ))
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    className={`badge ${item.status === "active"
                                                                        ? "bg-success"
                                                                        : "bg-danger"
                                                                        }`}
                                                                >
                                                                    {item.status
                                                                        ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
                                                                        : "-"}
                                                                </span>
                                                            </td>
                                                            {/* <td>
                                                                {item.created_at}
                                                            </td>
                                                            <td>
                                                                {item.updated_at}
                                                            </td> */}
                                                            <td>
                                                                {moment(item.created_at).format("DD MMM YYYY, hh:mm:ss A")}
                                                            </td>
                                                            <td>
                                                                {moment(item.updated_at).format("DD MMM YYYY, hh:mm:ss A")}
                                                            </td>
                                                            {/* <td
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => navigate(`/manageKnowledgebase/${item.id}`)}
                                                            >
                                                                <FaEdit size={18} />
                                                            </td> */}
                                                            <td
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() =>
                                                                    navigate("/manageKnowledgebase", {
                                                                        state: { id: item.id },
                                                                    })
                                                                }
                                                            >
                                                                <FaEdit size={18} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {!isLoading && intent?.length > 0 && (
                                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                                <div className="d-flex align-items-center gap-1 small">

                                                    <span>Show</span>

                                                    <select
                                                        className="form-select form-select-sm page-size-select"
                                                        value={rowsPerPage}
                                                        onChange={(e) => {
                                                            setRowsPerPage(Number(e.target.value));
                                                            setCurrentPage(1);
                                                        }}
                                                    >
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={15}>15</option>
                                                    </select>

                                                    <span>entries</span>

                                                </div>

                                                <div className="small text-muted">
                                                    Showing {startEntry} to {endEntry} of {totalRecords} entries
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    maxPagesToShow={rowsPerPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />

                                            </div>
                                        )}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    {showPreview && (
                        <div className="import-overlay">
                            <div className="import-box">

                                {/* Header */}
                                <div className="import-header">
                                    <div>
                                        <h4>Import Knowledge Base</h4>
                                        <p>Upload, review and import your data</p>
                                    </div>

                                    <button
                                        className="close-btn"
                                        onClick={() => {
                                            setShowPreview(false);
                                            setImportStep(1);
                                        }}
                                    >
                                        <FiX />
                                    </button>
                                </div>

                                {/* Stepper */}
                                <div className="import-steps">

                                    <div className={`step-item ${importStep >= 1 ? "active" : ""}`}>
                                        <div className="step-circle">
                                            <FiUploadCloud />
                                        </div>

                                        <div className="step-content">
                                            <h4>Upload</h4>
                                            <p>Select file</p>
                                        </div>
                                    </div>

                                    <div className={`step-line ${importStep >= 2 ? "active-line" : ""}`} />

                                    <div className={`step-item ${importStep >= 2 ? "active" : ""}`} onClick={handlePreviewIcon} style={previewData?.length > 0 ? { cursor: "pointer" } : {}}>
                                        <div className="step-circle">
                                            <FiFileText />
                                        </div>

                                        <div className="step-content">
                                            <h4>Preview</h4>
                                            <p>Check data</p>
                                        </div>
                                    </div>

                                    <div className={`step-line ${importStep == 3 ? "active-line" : ""}`} />

                                    <div className={`step-item ${importStep == 3 ? "active" : ""}`}>
                                        <div className="step-circle">
                                            <FiCheckCircle />
                                        </div>

                                        <div className="step-content">
                                            <h4>Import</h4>
                                            <p>Finish</p>
                                        </div>
                                    </div>

                                </div>

                                {/* Scrollable Content */}
                                <div className="import-body">

                                    {importStep === 1 && (
                                        <div
                                            className="upload-card"
                                            onDragOver={(e) => {
                                                e.preventDefault();
                                                e.currentTarget.classList.add("drag-active");
                                            }}
                                            onDragLeave={(e) => {
                                                e.currentTarget.classList.remove("drag-active");
                                            }}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                e.currentTarget.classList.remove("drag-active");

                                                const file = e.dataTransfer.files[0];
                                                if (file) {
                                                    handleExcelUpload(file);
                                                }
                                            }}
                                        >
                                            <div className="upload-icon">
                                                <FiUploadCloud />
                                            </div>

                                            <h3>Upload File</h3>

                                            <p>Drag & drop your file here or browse</p>

                                            <span className="me-2">
                                                Supported: PDF, DOCX, XLSX, CSV
                                            </span>

                                            <label className="upload-btn ">
                                                Choose File
                                                <input
                                                    hidden
                                                    type="file"
                                                    accept=".pdf,.docx,.xlsx,.csv"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) handleExcelUpload(file);
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}


                                    {importStep === 2 && (
                                        <div className="kb-tree">

                                            {previewData?.map((intent, intentIndex) => {

                                                const isIntentOpen = expandedIntent === intentIndex;

                                                return (
                                                    <div key={intentIndex} className="intent-card">

                                                        {/* INTENT HEADER */}
                                                        <div className="intent-top">

                                                            <div
                                                                className="intent-click"
                                                                onClick={() =>
                                                                    setExpandedIntent(
                                                                        isIntentOpen ? null : intentIndex
                                                                    )
                                                                }
                                                            >

                                                                <span className="collapse-icon">
                                                                    {isIntentOpen ? (
                                                                        <FiChevronDown />
                                                                    ) : (
                                                                        <FiChevronRight />
                                                                    )}
                                                                </span>


                                                                <h4 className="intent-title">
                                                                    {intent.intent}
                                                                    <span className="category-badge">
                                                                        Category
                                                                    </span>
                                                                </h4>

                                                            </div>


                                                            <div className="intent-actions">

                                                                <button className="icon-btn edit" onClick={() =>
                                                                    handleEditIntent(intent, intentIndex)}>
                                                                    <FiEdit2

                                                                    />
                                                                </button>


                                                                <button className="icon-btn delete"
                                                                    // onClick={handleDeleteIntent}
                                                                    onClick={() => {
                                                                        // console.log(intentIndex, "clicked index");
                                                                        handleDeleteIntent(intentIndex);
                                                                    }}
                                                                >
                                                                    <FiTrash2 />
                                                                </button>

                                                            </div>

                                                        </div>


                                                        {/* FLOWS */}
                                                        {isIntentOpen && (

                                                            <div className="flow-container">

                                                                {intent.flows?.map((flow, flowIndex) => {

                                                                    const flowKey = `${intentIndex}-${flowIndex}`;

                                                                    const isFlowOpen =
                                                                        expandedFlow === flowKey;


                                                                    return (

                                                                        <div
                                                                            key={flowIndex}
                                                                            className="flow-section"
                                                                        >

                                                                            {/* FLOW HEADER */}
                                                                            <div
                                                                                className="flow-title"
                                                                                onClick={() =>
                                                                                    setExpandedFlow(
                                                                                        isFlowOpen
                                                                                            ? null
                                                                                            : flowKey
                                                                                    )
                                                                                }
                                                                            >

                                                                                <span style={{ cursor: 'pointer' }}>
                                                                                    {isFlowOpen ? (
                                                                                        <FiChevronDown />
                                                                                    ) : (
                                                                                        <FiChevronRight />
                                                                                    )}
                                                                                </span>

                                                                                <span style={{ cursor: 'pointer' }}>
                                                                                    {flow.flow_name} <span className="category-badge">
                                                                                        Flow
                                                                                    </span>
                                                                                </span>

                                                                            </div>



                                                                            {/* STEPS */}
                                                                            {isFlowOpen && (

                                                                                <div>

                                                                                    {flow.steps?.map(step => (

                                                                                        <div
                                                                                            key={step.id}
                                                                                            className="step-item-card"
                                                                                        >

                                                                                            <div className="step-badge">
                                                                                                Question {step.step_order}
                                                                                            </div>


                                                                                            <div className="step-content-card">

                                                                                                <div className="step-question">
                                                                                                    {step.question}
                                                                                                </div>


                                                                                                {step.solution_text && (

                                                                                                    <div className="solution-box">
                                                                                                        {step.solution_text}
                                                                                                    </div>

                                                                                                )}



                                                                                                {step.options?.map(option => (

                                                                                                    <div
                                                                                                        key={option.id}
                                                                                                        className="option-row"
                                                                                                    >

                                                                                                        <span>
                                                                                                            {option.option_label}
                                                                                                        </span>


                                                                                                        <span>

                                                                                                            {
                                                                                                                option.is_resolution
                                                                                                                    ? option.resolution_text
                                                                                                                    : `Go to Question ${option.next_step_id}`
                                                                                                            }

                                                                                                        </span>

                                                                                                    </div>

                                                                                                ))}


                                                                                            </div>

                                                                                        </div>

                                                                                    ))}

                                                                                </div>

                                                                            )}

                                                                        </div>

                                                                    );

                                                                })}

                                                            </div>

                                                        )}

                                                    </div>

                                                );

                                            })}

                                            {previewData.length === 0 && (
                                                <div className="empty-state-container">
                                                    <div className="empty-state-icon">
                                                        <FiInbox />
                                                    </div>

                                                    <h3 className="empty-state-title">
                                                        No Category Found
                                                    </h3>

                                                    {/* <p className="empty-state-text">
                                                        There are no categories available to display.
                                                    </p> */}
                                                </div>
                                            )}

                                        </div>
                                    )}

                                    {importStep === 3 && (
                                        <div className="upload-card">
                                            <div className="upload-icon success">
                                                <FiUploadCloud />
                                            </div>

                                            <h3>Ready to Import</h3>
                                            <p>{previewData.length} records will be imported</p>
                                        </div>
                                    )}

                                    {importStep === 4 && (
                                        <div className="validation-wrapper">

                                            <div className="validation-header">

                                                <div className="validation-header-icon">
                                                    <FiAlertTriangle />
                                                </div>

                                                <div>
                                                    <h3>Import Validation Failed</h3>

                                                    <p>
                                                        {validationErrors.length} validation error
                                                        {validationErrors.length > 1 ? "s" : ""} found in the uploaded file.
                                                    </p>
                                                </div>

                                            </div>

                                            <div className="validation-errors">

                                                {validationErrors?.map((error, index) => (
                                                    <div
                                                        key={index}
                                                        className="validation-error-card"
                                                    >
                                                        <div className="validation-error-left">
                                                            <FiXCircle />
                                                        </div>

                                                        <div className="validation-error-content">

                                                            <div className="validation-row-label">
                                                                Row {error.index + 1}
                                                            </div>

                                                            <div className="validation-error-message">
                                                                {error.message}
                                                            </div>

                                                        </div>
                                                    </div>
                                                ))}

                                            </div>

                                            {/* <div className="validation-footer">

            <button
                className="btn btn-outline-secondary"
                onClick={() => setImportStep(2)}
            >
                Back to Preview
            </button>

            <button
                className="btn btn-primary"
                onClick={() => setImportStep(1)}
            >
                Upload New File
            </button>

        </div> */}

                                        </div>
                                    )}

                                </div>

                                {/* Footer */}
                                <div className="import-footer">

                                    {importStep === 4 && (
                                        <button
                                            className="import-btn"
                                            onClick={() => setImportStep(2)}
                                        >
                                            Preview
                                        </button>
                                    )}

                                    {importStep === 2 && previewData?.length == 0 && (
                                        <button
                                            className="import-btn btn-primary"
                                            onClick={() => setImportStep(1)}
                                        >
                                            Back
                                        </button>
                                    )}

                                    <button
                                        className="cancel-btn"
                                        onClick={() => {
                                            setShowPreview(false);
                                            setImportStep(1);
                                            setPreviewData([])
                                            setExpandedFlows({})
                                            setExpandedFlow(null)
                                            setExpandedIntent(null)
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    {importStep === 2 && previewData?.length > 0 && (
                                        <button
                                            className="import-btn"
                                            onClick={() => setImportStep(3)}
                                        >
                                            Continue
                                        </button>
                                    )}


                                    {importStep === 3 && (
                                        <button className="import-btn" onClick={handleUpload}>
                                            Import {previewData?.length} Records
                                        </button>
                                    )}

                                </div>

                            </div>
                        </div>
                    )}

                    {showEditModal && editData && (
                        <div className="kb-edit-overlay">

                            <div className="kb-editor">

                                <div className="kb-editor-header">
                                    <div>
                                        <h2>Edit Knowledge Base</h2>
                                        <p>Modify your conversation flow</p>
                                    </div>

                                    {/* <button
                                        className="kb-close"
                                        onClick={() => setShowEditModal(false)}
                                    >
                                        <FiX />
                                    </button> */}
                                </div>


                                <div className="kb-editor-content">


                                    <div className="kb-tree-panel">

                                        {/* <h4>Structure</h4> */}

                                        <div className="tree-intent">
                                            <span>Category</span>
                                            <strong>{editData.intent}</strong>
                                        </div>
                                        {/* 
                                        {editData.flows.map((flow, fi) => (
                                            <div className="tree-flow" key={fi}>

                                                <span>Flow</span>
                                                <strong>{flow.flow_name}</strong>


                                                {flow.steps.map(step => (

                                                    <div className="tree-step" key={step.id}>
                                                        Step {step.step_order}
                                                    </div>
                                                ))}
                                            </div>
                                        ))} */}
                                    </div>



                                    <div className="kb-form-panel">

                                        <h4 className="mb-4">Category Details</h4>

                                        <div className="form-block">

                                            <label>Category Name</label>

                                            <input
                                                value={editData.intent}
                                                onChange={(e) =>
                                                    updateEditValue(
                                                        ["intent"],
                                                        e.target.value
                                                    )}
                                            />
                                            <label>Description</label>

                                            <textarea
                                                value={editData.description}
                                                onChange={(e) =>
                                                    updateEditValue(
                                                        ["description"],
                                                        e.target.value
                                                    )}
                                            />

                                            <label>Keywords</label>

                                            <div className="d-flex gap-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter keyword"
                                                    value={keywordInput}
                                                    onChange={(e) => setKeywordInput(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            addKeyword();
                                                        }
                                                    }}
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={addKeyword}
                                                >
                                                    <FaPlus />
                                                </button>
                                            </div>

                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                {editData.keywords?.map((kw, index) => (
                                                    <span
                                                        key={index}
                                                        className="keyword-chip"
                                                    >
                                                        {kw}

                                                        <button
                                                            type="button"
                                                            className="keyword-chip-remove"
                                                            onClick={() => removeKeyword(index)}
                                                        >
                                                            <FaTimes size={12} />
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>

                                        </div>

                                        <h4 className="mb-4">
                                            Flow Details
                                        </h4>
                                        {editData.flows.map((flow, fi) => (


                                            <div className="form-block" key={fi}>

                                                <div
                                                    className="flow-header"
                                                    onClick={() => toggleFlow(fi)}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <h5>{flow.flow_name || `Flow ${fi + 1}`}</h5>
                                                    <span className="flow-toggle-icon">
                                                        {expandedFlows[fi] ? <FaChevronUp /> : <FaChevronDown />}
                                                    </span>
                                                </div>

                                                {expandedFlows[fi] && (
                                                    <>
                                                        <label>Flow Name</label>

                                                        <input
                                                            className="mb-3"
                                                            value={flow.flow_name}
                                                            onChange={(e) =>
                                                                updateEditValue(
                                                                    ["flows", fi, "flow_name"],
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                        <textarea
                                                            value={flow.flow_description || ""}
                                                            onChange={(e) =>
                                                                updateEditValue(
                                                                    ["flows", fi, "flow_description"],
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                        {flow.steps.map((step, si) => (
                                                            <div className="step-box" key={step.id}>

                                                                <div className="step-head">
                                                                    <b>
                                                                        Question {si + 1}
                                                                    </b>
                                                                </div>

                                                                <label>Question</label>

                                                                <textarea
                                                                    value={step.question}
                                                                    onChange={(e) =>
                                                                        updateEditValue(
                                                                            [
                                                                                "flows",
                                                                                fi,
                                                                                "steps",
                                                                                si,
                                                                                "question"
                                                                            ],
                                                                            e.target.value
                                                                        )}
                                                                />

                                                                <label>Question Order</label>

                                                                {/* <input
                                                                    type="number"
                                                                    min="1"
                                                                    value={step.step_order || ""}
                                                                    onChange={(e) =>
                                                                        updateEditValue(
                                                                            [
                                                                                "flows",
                                                                                fi,
                                                                                "steps",
                                                                                si,
                                                                                "step_order"
                                                                            ],
                                                                            Number(e.target.value)
                                                                        )
                                                                    }
                                                                /> */}

                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    value={step.step_order || ""}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.replace(/\D/g, ""); // allow only digits

                                                                        updateEditValue(
                                                                            [
                                                                                "flows",
                                                                                fi,
                                                                                "steps",
                                                                                si,
                                                                                "step_order"
                                                                            ],
                                                                            value === "" ? "" : Number(value)
                                                                        );
                                                                    }}
                                                                />

                                                                <label>Solution</label>

                                                                <textarea
                                                                    value={step.solution_text || ""}
                                                                    onChange={(e) =>
                                                                        updateEditValue(
                                                                            [
                                                                                "flows",
                                                                                fi,
                                                                                "steps",
                                                                                si,
                                                                                "solution_text"
                                                                            ],
                                                                            e.target.value
                                                                        )}
                                                                />
                                                                {step.options?.length > 0 && (

                                                                    <div className="options">

                                                                        <h4>Options</h4>

                                                                        {step.options.map((option, oi) => (

                                                                            <div className="option-box" key={option.id}>


                                                                                <div>
                                                                                    <label>Option</label>

                                                                                    <input
                                                                                        value={option.option_label}
                                                                                        placeholder="Option label"
                                                                                        onChange={(e) =>
                                                                                            updateEditValue(
                                                                                                [
                                                                                                    "flows",
                                                                                                    fi,
                                                                                                    "steps",
                                                                                                    si,
                                                                                                    "options",
                                                                                                    oi,
                                                                                                    "option_label"
                                                                                                ],
                                                                                                e.target.value
                                                                                            )}
                                                                                    />

                                                                                </div>

                                                                                <div>
                                                                                    <label>Is Resolution</label>

                                                                                    <select
                                                                                        value={option.is_resolution}
                                                                                        onChange={(e) =>
                                                                                            updateEditValue(
                                                                                                [
                                                                                                    "flows",
                                                                                                    fi,
                                                                                                    "steps",
                                                                                                    si,
                                                                                                    "options",
                                                                                                    oi,
                                                                                                    "is_resolution"
                                                                                                ],
                                                                                                Number(e.target.value)
                                                                                            )}
                                                                                    >

                                                                                        <option value={0}>No</option>
                                                                                        <option value={1}>Yes</option>

                                                                                    </select>
                                                                                </div>

                                                                                {option.is_resolution === 1 ? (

                                                                                    <div>
                                                                                        <label>Resolution</label>

                                                                                        <input
                                                                                            value={option.resolution_text || ""}
                                                                                            placeholder="Resolution text"
                                                                                            onChange={(e) =>
                                                                                                updateEditValue(
                                                                                                    [
                                                                                                        "flows",
                                                                                                        fi,
                                                                                                        "steps",
                                                                                                        si,
                                                                                                        "options",
                                                                                                        oi,
                                                                                                        "resolution_text"
                                                                                                    ],
                                                                                                    e.target.value
                                                                                                )}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div>
                                                                                        <label>Next Step Question</label>

                                                                                        <select
                                                                                            className="step-select"
                                                                                            value={option.next_step_id || ""}
                                                                                            onChange={(e) =>
                                                                                                updateEditValue(
                                                                                                    [
                                                                                                        "flows",
                                                                                                        fi,
                                                                                                        "steps",
                                                                                                        si,
                                                                                                        "options",
                                                                                                        oi,
                                                                                                        "next_step_id"
                                                                                                    ],
                                                                                                    Number(e.target.value)
                                                                                                )}
                                                                                        >
                                                                                            {/* <option value="">
                                                                                        Select next step
                                                                                    </option> */}


                                                                                            {flow.steps
                                                                                                .filter(item => item.id !== step.id)
                                                                                                .map(nextStep => (

                                                                                                    <option
                                                                                                        key={nextStep.id}
                                                                                                        value={nextStep.id}
                                                                                                    >

                                                                                                        {/* Step {nextStep.step_order} - */}
                                                                                                        {nextStep.question}

                                                                                                    </option>

                                                                                                ))}
                                                                                        </select>
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        ))}


                                    </div>
                                </div>

                                <div className="kb-editor-footer">
                                    <button
                                        className="cancel-btn"
                                        onClick={() => setShowEditModal(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="save-btn"
                                        onClick={() => {
                                            setPreviewData(prev => {
                                                const copy = [...prev];
                                                copy[editIndex] = editData;
                                                return copy;
                                            });
                                            setShowEditModal(false);
                                            toastService.success("Changes saved successfully!");
                                        }}
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default KBCategory;